module.exports = __webpack_public_path__ + "img/image03.d5ffd4df.jpg";